module.exports = __webpack_public_path__ + "fonts/74d27a37a428a382263701c66efe7f8b.6a231f53.woff";